import React, { ReactNode } from "react";
import { Box, BoxProps } from "@chakra-ui/react";

interface Props {
  children: ReactNode;
}

const Card: React.FC<Props & BoxProps> = ({
  children,
  ...rest
}: Props & BoxProps) => {
  return (
    <Box
      p={8}
      bg="gray.800"
      boxShadow="0px 4px 7px -1px rgba(0, 0, 0, 0.25)"
      rounded={15}
      position="relative"
      w="100%"
      {...rest}
    >
      {children}
    </Box>
  );
};

export default Card;
